import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useSaveSheet = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.post("/Sheet/CreateOrEditSheet", formData);
  });
  return mutation;
};
export default useSaveSheet;
